/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useState } from "react";
import { inputCss } from "./types";
import { MuiIconName } from "../IconSelector/muiIconNames";
import FlowioTextInput from "../FlowioTextInput";

export type FilterProps = {
  callback: (filteredArr: MuiIconName[]) => void;
  searchArr: MuiIconName[];
  placeholder?: string;
};

const Filter = ({ callback, searchArr, placeholder }: FilterProps) => {
  const [searchText, setSearchText] = useState("");

  const onChangeText = (newSearchText: string) => {
    setSearchText(newSearchText);
    const newArr = searchArr.filter((item: string) =>
      item.toLowerCase().includes(newSearchText.toLowerCase())
    );
    callback(newArr);
  };

  return (
    <FlowioTextInput
      value={searchText}
      placeholder={placeholder}
      onChange={onChangeText}
      css={inputCss}
    />
  );
};

export default Filter;
